/**
 * Product Gallery Swiper Initialization
 * Creates a repeating carousel with thumbnail navigation
 */

function initProductGallerySwiper() {
  const galleryContainer = document.querySelector('.product-gallery-swiper');
  if (!galleryContainer) return;

  const mainSwiperEl = galleryContainer.querySelector('.product-gallery-main');
  const thumbsSwiperEl = galleryContainer.querySelector('.product-gallery-thumbs');
  
  if (!mainSwiperEl) return;

  // Initialize thumbnails swiper first
  let thumbsSwiper = null;
  
  if (thumbsSwiperEl) {
    thumbsSwiper = new Swiper(thumbsSwiperEl, {
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesProgress: true,
      freeMode: true,
      loop: false, // Thumbnails don't need to loop
      breakpoints: {
        320: {
          slidesPerView: 4,
          spaceBetween: 8,
        },
        480: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        750: {
          slidesPerView: 5,
          spaceBetween: 12,
        },
        990: {
          slidesPerView: 6,
          spaceBetween: 12,
        },
        1200: {
          slidesPerView: 7,
          spaceBetween: 12,
        },
      },
    });
  }

  // Initialize main gallery swiper
  const mainSwiper = new Swiper(mainSwiperEl, {
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    
    // Navigation arrows
    navigation: {
      nextEl: '.product-gallery-main .swiper-button-next',
      prevEl: '.product-gallery-main .swiper-button-prev',
    },
    
    // Thumbnail connection
    thumbs: thumbsSwiper ? {
      swiper: thumbsSwiper,
    } : undefined,
    
    // Lazy loading for performance
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
    
    // Smooth transitions
    speed: 400,
    effect: 'slide',
    
    // Accessibility
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous image',
      nextSlideMessage: 'Next image',
      firstSlideMessage: 'This is the first image',
      lastSlideMessage: 'This is the last image',
      paginationBulletMessage: 'Go to image {{index}}',
    },
    
    // Events
    on: {
      slideChange: function() {
        // Pause any playing videos when slide changes
        const activeSlide = this.slides[this.activeIndex];
        const allSlides = this.slides;
        
        allSlides.forEach((slide) => {
          const video = slide.querySelector('video');
          const deferredMedia = slide.querySelector('deferred-media');
          
          if (video && slide !== activeSlide) {
            video.pause();
          }
          
          // Reset deferred media if not active
          if (deferredMedia && slide !== activeSlide) {
            const pauseButton = deferredMedia.querySelector('.deferred-media__poster');
            if (pauseButton) {
              // Reset to poster state
            }
          }
        });
      },
      init: function() {
        // Trigger lazy load on init
        this.lazy.load();
      }
    },
  });

  // Store swiper instance for potential external access
  galleryContainer.swiperMain = mainSwiper;
  galleryContainer.swiperThumbs = thumbsSwiper;

  // Handle variant changes - update to correct slide
  document.addEventListener('variant:changed', (event) => {
    const variantMediaId = event.detail?.mediaId;
    if (variantMediaId && mainSwiper) {
      const slideIndex = findSlideIndexByMediaId(mainSwiper, variantMediaId);
      if (slideIndex !== -1) {
        mainSwiper.slideToLoop(slideIndex);
      }
    }
  });

  return { mainSwiper, thumbsSwiper };
}

/**
 * Find slide index by media ID
 */
function findSlideIndexByMediaId(swiper, mediaId) {
  const slides = swiper.slides;
  for (let i = 0; i < slides.length; i++) {
    const slide = slides[i];
    if (slide.dataset.mediaId === mediaId) {
      return i;
    }
  }
  return -1;
}

/**
 * Initialize on DOM ready
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductGallerySwiper);
} else {
  initProductGallerySwiper();
}

/**
 * Re-initialize on Shopify section refresh (Theme Editor)
 */
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product-gallery-swiper')) {
      initProductGallerySwiper();
    }
  });
}

/**
 * Expose globally for manual initialization if needed
 */
window.initProductGallerySwiper = initProductGallerySwiper;

